import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import DailyReportsServices from "../../services/axiosServices/apiServices/DailyReportsServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { StockAdjustmentTable } from "./stockAdjustmentTable";
import { CommonValidationMessages } from "../../utils/Messages";
import { isValidForm } from "../../utils/validation/CommonValidator";
import moment from "moment";

ModuleRegistry.registerModules([AllCommunityModule]);

class StockAdjustment extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isModalOpen: false,
            roleId: 0,
            itemRowData: [],
            itemObject: {
                adjNo: '',
                idItem: 0,
                itemName: '',
                itemCategory: '',
                drawingNo: '',
                currentStock: '',
                idStockAdjustment: ''
            },
            adjustmentObject: {
                itemRate: '',
                creditStock: '',
                debitStock: '',
                reason: '',
                date: '',
                keyId: null
            },
            colDefs: [
                {
                    headerName: "Sr no", field: "idItem",
                    width: Math.max(window.innerWidth * 0.045, 50),
                    filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Adj No", field: "adjNo",
                    width: Math.max(window.innerWidth * 0.045, 50),
                    filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Select",
                    field: "status",
                    width: Math.max(window.innerWidth * 0.05, 50),
                    pinned: "left",

                    cellRenderer: "agCheckboxCellRenderer",

                    valueGetter: (params) => params.data.status === 1,

                    valueSetter: (params) => {
                        params.data.status = params.newValue ? 1 : 0;
                        return true;
                    },

                    editable: true,

                    filter: "agSetColumnFilter",
                    floatingFilter: true,
                    filterParams: {
                        values: [true, false],
                        valueFormatter: (params) => params.value ? "Selected" : "Not Selected"
                    }
                },
                {
                    headerName: "Drawing no", field: "drawingNo",
                    width: Math.max(window.innerWidth * 0.1, 50),
                    filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Item category", field: "itemCategory",
                    width: Math.max(window.innerWidth * 0.09, 50),
                    filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Item name", field: "itemName",
                    width: window.innerWidth * 0.16,
                    filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Unit", field: "unitDescription",
                    minWidth: window.innerWidth * 0.05,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
                // {
                //     headerName: "Current stock", field: "currentStock",
                //     minWidth: window.innerWidth * 0.06,
                //     flex: 1, filter: true,
                //     floatingFilter: true,
                // },
                // {
                //     headerName: "Audit stock", field: "auditStock",
                //     minWidth: window.innerWidth * 0.05,
                //     flex: 1, filter: true,
                //     floatingFilter: true,
                // },
                // {
                //     headerName: "Audit date", field: "auditDate",
                //     minWidth: window.innerWidth * 0.07,
                //     flex: 1, filter: true,
                //     floatingFilter: true,
                //     valueFormatter: (params) => {
                //         if (!params.value) return "";
                //         const date = new Date(params.value);
                //         return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                //     },
                // },
                {
                    headerName: "Credit", field: "creditStock",
                    minWidth: window.innerWidth * 0.08,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Debit", field: "debitStock",
                    minWidth: window.innerWidth * 0.08,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
                // {
                //     headerName: "Closing stock", field: "closingStock",
                //     minWidth: window.innerWidth * 0.08,
                //     flex: 1, filter: true,
                //     floatingFilter: true,
                // },
                {
                    headerName: "Status", field: "approvalStatus",
                    minWidth: window.innerWidth * 0.08,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
            ],
            rowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            validationRules: {
                reason: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "reason"
                        ),
                    },
                ],
                itemRate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "itemRate"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
        this.gridApi = null;
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, roleId: prop.roleId }, () => {
                this.usp_Master_ItemSelectForItemStockAdjustment();
            });
        }
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);
        window.addEventListener("resize", this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    usp_Master_ItemSelectForItemStockAdjustment = () => {
        let idCompany = this.state.idCompany;
        this.dailyReportsServices.usp_Master_ItemSelectForItemStockAdjustment(idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({ rowData: data }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                }

            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);

    };
    removeDefaultBorders = () => {
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        removeCellBorders();

        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };


    usp_Master_ItemStockAdjustmentInsert = () => {
        let request = [];
        let rData = this.state.itemObject;
        let data = {
            idItem: rData.idItem,
            currentStock: rData.currentStock,
            auditStock: 0,
            auditDate: '',
            idUser: 0
        };
        request.push(data);
        this.dailyReportsServices.usp_Master_ItemStockAdjustmentInsert(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                this.SwalServices.Success("Save sucessfully.");
            }
        });
    }

    usp_Master_ItemUpdateStockAdjustment = () => {
        let request = {
            idItem: 0,
            currentStock: 0.00,
            auditDate: new Date(),
            closingStock: 0
        };
        this.dailyReportsServices.usp_Master_ItemUpdateStockAdjustment(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                this.SwalServices.Success("Update sucessfully.");
            }
        });
    }

    usp_Master_ItemSelectForItemStockAdjustmentChangeAsPerDate = () => {
        let request = {
            idCompany: 0,
            date: new Date(),
            idItem: 0
        };
        this.dailyReportsServices.usp_Master_ItemSelectForItemStockAdjustmentChangeAsPerDate(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                this.SwalServices.Success("sucessfully.");
            }
        });
    }

    onRowDoubleClicked = (event) => {
        this.getAdjustmentSelectById(event.data.idItem);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    getAdjustmentSelectById = (idItem) => {
        if (idItem > 0) {
            this.dailyReportsServices.getAdjustmentSelectById(idItem).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let itemObject = this.state.itemObject;
                    itemObject.adjNo = res.adjNo;
                    itemObject.itemName = res.itemName;
                    itemObject.idItem = idItem
                    itemObject.updateStatus = 1;
                    itemObject.itemCategory = res.itemCategory
                    itemObject.drawingNo = res.drawingNo;
                    itemObject.currentStock = res.currentStock
                    itemObject.idStockAdjustment = res.idStockAdjustment

                    let adjustmentObject = this.state.adjustmentObject
                    adjustmentObject.itemRate = res.itemRate
                    adjustmentObject.date = moment(new Date()).format('YYYY-MM-DD')

                    if (itemListRecords?.length > 0) {
                        itemListRecords.map((details, keyId) => {
                            let obj = {
                                idStockAdjustment: details.idStockAdjustment,
                                idStockAdjustmentItems: details.idStockAdjustmentItems,
                                creditStock: details.creditStock,
                                debitStock: details.debitStock,
                                itemRate: details.itemRate,
                                reason: details.reason,
                                date: details.date ? moment(details.date).format('YYYY-MM-DD') : '',
                                keyId: keyId + 1,
                                status: details.status
                            }
                            itemList.push(obj);
                        })
                    }
                    this.setState({ itemObject: itemObject, adjustmentObject: adjustmentObject, isModalOpen: true, itemRowData: itemList });
                }
            });
        }
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.adjustmentObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    insert = (flag) => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.adjustmentObject;
            const credit = Number(details.creditStock);
            const debit = Number(details.debitStock);
            const itemRate = Number(details.itemRate);

            if ((credit > 0 && debit > 0) || (credit === 0 && debit === 0)) {
                this.SwalServices.Alert("Please enter either Credit Stock OR Debit Stock. Both are not allowed.");
                return;
            }

            if (flag === 'Insert') {
                let itemList = [...this.state.itemRowData];
                let obj = {
                    creditStock: credit,
                    debitStock: debit,
                    date: details.date,
                    reason: details.reason,
                    itemRate: itemRate,
                    status: 'Pending'
                }
                itemList.push(obj);
                itemList.map((x, key) => {
                    x.keyId = key + 1;
                });
                this.setState({ itemRowData: itemList }, () => {
                    this.resetAdjustmentObject()
                });
            }
            else if (flag === 'Update') {
                let itemList2 = [...this.state.itemRowData];
                let obj2 = {
                    creditStock: credit,
                    debitStock: debit,
                    date: details.date,
                    reason: details.reason,
                    itemRate: itemRate,
                    status: 'Pending'
                };
                itemList2[details.keyId - 1] = obj2;
                itemList2.map((x, key) => {
                    x.keyId = key + 1;
                });
                this.setState({ itemRowData: itemList2 }, () => {
                    this.resetAdjustmentObject()
                });
            }
        } else {
            this.SwalServices.Alert("Please Enter Valid Data");
        }
    }

    resetAdjustmentObject = () => {
        let detials = this.state.adjustmentObject
        detials.creditStock = ''
        detials.debitStock = ''
        detials.date = ''
        detials.reason = ''
        detials.itemRate = ''
        detials.keyId = null
        this.setState({ adjustmentObject: detials })
    }

    handleChange = (event, name) => {
        let details = this.state.adjustmentObject
        details[name] = event.target.value
        this.setState({ adjustmentObject: details })
    }

    handleCellClickItemList = (event) => {
        let details = this.state.adjustmentObject
        details.creditStock = event.data.creditStock
        details.debitStock = event.data.debitStock
        details.date = event.data.date
        details.reason = event.data.reason
        details.itemRate = event.data.itemRate
        details.keyId = event.rowIndex + 1
        this.setState({ adjustmentObject: details })
    }

    submit = () => {

        let request = {
            itemList: this.state.itemRowData,
            idStockAdjustment: this.state.itemObject.idStockAdjustment,
            idItem: this.state.itemObject.idItem,
            currentStock: this.state.itemObject.currentStock,
            idCompany: this.state.idCompany
        }

        this.dailyReportsServices.usp_Master_ItemStockAdjustmentInsert_new(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data !== null) {
                    this.SwalServices.Success("Updated successfully.");
                    if (this.state.urlId) {
                        this.setState({ route: '/ledger-report' });
                    }
                    else {
                        this.setState({ isModalOpen: false }, () => {
                            this.resetAllData()
                            this.usp_Master_ItemSelectForItemStockAdjustment()
                        });
                    }
                }
            }
        });
    };

    resetAllData = () => {
        this.resetAdjustmentObject()

        let itemObject = this.state.itemObject
        itemObject.itemName = ''
        itemObject.adjNo = ''
        itemObject.idItem = ''
        itemObject.itemCategory = ''
        itemObject.drawingNo = ''
        itemObject.currentStock = ''
        itemObject.idStockAdjustment = ''
        this.setState({ itemObject: itemObject })

        let validState = this.state.validState
        validState.isValid = true
        validState.error = ''
        this.setState({ validState: validState, itemRowData: [] })
    }

    delete = (keyId) => {
        let itemRowData = this.state.itemRowData.filter(item => item.keyId !== keyId);
        this.setState({ itemRowData }, () => {
            this.resetAdjustmentObject()
        });
    }

    resetAdjustmentObject = () => {
        let adjustmentObject = this.state.adjustmentObject
        adjustmentObject.itemRate = ''
        adjustmentObject.creditStock = ''
        adjustmentObject.debitStock = ''
        adjustmentObject.reason = ''
        adjustmentObject.date = ''
        adjustmentObject.keyId = null
        this.setState({ adjustmentObject: adjustmentObject })
    }

    handleUpdateStockAdjustmentStatus = (rowData, status) => {
        let request = [rowData.idStockAdjustmentItems, status]
        this.dailyReportsServices.updateStatusForStockAdjustment(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0][0];
                this.getAdjustmentSelectById(data.idItem)
                this.usp_Master_ItemSelectForItemStockAdjustment()
                this.SwalServices.Success("Updated successfully.");
            }
        });
    }

    printAdjustmentReport = () => {
        if (this.state.itemObject.idItem > 0) {
            let request = [this.state.itemObject.idItem];
            this.dailyReportsServices.downloadAdjustmentReport(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL, "_blank");
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    render() {
        return (
            <div className='stock-adjustment'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <div className="table w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[79vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Stock adjustment</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                    onGridReady={this.onGridReady}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'} // Custom loading text
                                />
                            </div>
                            <StockAdjustmentTable
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                itemObject={this.state.itemObject}
                                adjustmentObject={this.state.adjustmentObject}
                                insert={this.insert.bind(this)}
                                itemRowData={this.state.itemRowData}
                                handleChange={this.handleChange.bind(this)}
                                handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                                submit={this.submit.bind(this)}
                                delete={this.delete.bind(this)}
                                clear={this.resetAdjustmentObject.bind(this)}
                                roleId={this.state.roleId}
                                handleUpdateStockAdjustmentStatus={this.handleUpdateStockAdjustmentStatus.bind(this)}
                                close={this.setOpenModel.bind(this)}
                                printAdjustment={this.printAdjustmentReport.bind(this)}
                            />
                        </div>
                        <div className="btn-grp inline-flex gap-[10px] absolute top-[-43px] right-0">
                            {/* <button className="btns update-btn"
                                onClick={() => { this.usp_Master_ItemStockAdjustmentInsert() }}
                            >Save</button> */}
                            {/* <button className="btns delete-btn"
                            //onClick={() => { this.usp_Master_ItemUpdateStockAdjustment() }}
                            >Delete</button> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default StockAdjustment;